import React from 'react';
import IndicatorBottomSvg from './IndicatorBottomSvg';
import IndicatorTopSVG from './IndicatorTopSVG';
// import { TriangeIcon } from '../Icons';

// gradientColor can be "purple", "green", "blue" : TODO: TS Interface

// indicator is { position: "top"|"bottom", content: JSX.Element }

const gradientColorValue = {
  purple: {
    start: '#684AA7',
    end: '#E15F7A',
  },
  green: {
    start: '#3D8D7F',
    end: '#ABD2CC',
  },
  blue: {
    start: '#2760CF',
    end: '#879DD6',
  },
};

function ProgressBar({
  progress,
  bit,
  height,
  width,
  bold,
  gradientColor = 'purple',
  indicator,
  percentage,
}) {
  return (
    <div className='flex items-center gap-2'>
      {!bit && (
        <span className={`${bold ? 'font-bold' : ''}`}>
          {progress * 100 > 100 ? 100 : parseInt(progress * 100) || 0}%
        </span>
      )}
      <div
        className='relative w-full'
        style={{ width: `${!width ? '100%' : width}` }}
      >
        {indicator && (
          <div
            className='absolute'
            style={{
              left: `${
                progress === 0
                  ? -4.8
                  : progress * 100 > 100
                  ? 94
                  : parseInt(progress * 100 - 6) || 0
              }%`,
              [indicator.position]: -40,
            }}
          >
            <div className='flex flex-col items-center'>
              {indicator.position === 'bottom' && (
                <div className='-mb-0.5'>
                  <IndicatorBottomSvg />
                </div>
              )}
              <div className='flex items-center justify-center w-8 h-8 bg-white border-2 border-solid rounded-full border-learn-primary'>
                {indicator.content}
              </div>
              {indicator.position === 'top' && (
                <div className='-mt-0.5'>
                  <IndicatorTopSVG />
                </div>
              )}
            </div>
          </div>
        )}
        <div
          className='h-2 bg-gray-300 rounded-full'
          style={{
            height: height ?? '8px',
          }}
        />
        <div
          className='absolute top-0 h-2 rounded-lg'
          style={{
            background: `linear-gradient(90deg, ${gradientColorValue[gradientColor].start} 21.47%, ${gradientColorValue[gradientColor].end} 113.19%)`,
            width: `${
              progress * 100 > 100 ? 100 : parseInt(progress * 100) || 0
            }%`,
            height: height ?? '8px',
          }}
        />
        {percentage && progress !== 0 && (
          <div
            className='absolute flex flex-col items-center justify-center -ml-6'
            style={{
              left: `${
                progress * 100 > 100 ? 100 : parseInt(progress * 100) || 0
              }%`,
            }}
          >
            {/* <TriangeIcon iconStyle='absolute top-0' /> */}
            <div
              className='h-6 w-12 text-white rounded-full mt-1.5 flex justify-center items-center text-sm'
              style={{
                background:
                  'linear-gradient(90deg, #684AA7 21.47%, #E15F7A 113.19%)',
              }}
            >
              {progress * 100 > 100 ? 100 : parseInt(progress * 100) || 0} %
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProgressBar;
